import Component from "flarum/Component";
import app from "flarum/app";
import LoadingIndicator from "flarum/components/LoadingIndicator";
import Button from "flarum/components/Button";
import Select from 'flarum/common/components/Select';
import Stream from 'flarum/utils/Stream';

import DecorationStorePurchaseListItem from "./DecorationStorePurchaseListItem";
import navigationOptionDropdown from "../common/util/navigationOptionDropdown";

export default class DecorationStorePurchaseListPage extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = true;
    this.purchaseHistoryList = [];
    this.moreResults = false;
    this.filterItemType = Stream("-1");
    this.filterItemPurchaseType = Stream("-1");

    const itemTypeList = app.forum.attribute("decorationStoreItemTypes");
    this.itemTypeOption = {};
    this.itemTypeOption['-1'] = app.translator.trans('ziven-decoration-store.lib.item-type-all');

    for(let index in itemTypeList){
      const itemTypeValue = itemTypeList[index];
      this.itemTypeOption[itemTypeValue] = app.translator.trans('ziven-decoration-store.lib.item-type-'+itemTypeValue);
    }
    
    this.loadResults();
  }

  view() {
    let loading;
    let itemCount = 0;

    if(this.loading){
      loading = LoadingIndicator.component({ size: "large" });
    }

    return (
      <div>
        <div className="DecorationPageHeaderContainer">
          <div>
            {navigationOptionDropdown("item2")}
          </div>
        </div>

        <div className="DecorationStorePurchaseButtonsContainer">
          <div className="DecorationStoreFiltersFlexCard">
            <div className="DecorationStoreFiltersCardsListItem DecorationStoreFiltersCard">
              <Select
                value={this.filterItemType()}
                className="DecorationStoreSelectionList" 
                disabled={this.loading}
                options={this.itemTypeOption}
                buttonClassName="Button"
                onchange={(e) => {
                  this.filterItemType(e);
                  this.filterItem(e)
                }}
              />
            </div>
            <div className="DecorationStoreFiltersCardsListItem DecorationStoreFiltersCard">
              <Select
                value={this.filterItemPurchaseType()}
                className="DecorationStoreSelectionList" 
                disabled={this.loading}
                options={{
                  '-1': app.translator.trans('ziven-decoration-store.lib.item-purchase-type-all'),
                  'onetime': app.translator.trans('ziven-decoration-store.lib.item-purchase-type-onetime'),
                  'monthly': app.translator.trans('ziven-decoration-store.lib.item-purchase-type-monthly'),
                  'yearly': app.translator.trans('ziven-decoration-store.lib.item-purchase-type-yearly'),
                }}
                buttonClassName="Button"
                onchange={(e) => {
                  this.filterItemPurchaseType(e);
                  this.filterItem(e)
                }}
              />
            </div>
          </div>
        </div>

        <div id="decorationStorePurchaseHistoryContainer">
          {this.purchaseHistoryList.map((itemPurchaseData) => {
            return (
              <div itemID={itemPurchaseData.id()} style="margin-top:5px;background: var(--body-bg);">
                {DecorationStorePurchaseListItem.component({ itemPurchaseData })}
              </div>
            );
          })}
        </div>

        {!this.loading && this.purchaseHistoryList.length===0 && (
          <div>
            <div style="font-size:1.4em;color: var(--muted-more-color);text-align: center;line-height: 100px;">{app.translator.trans("ziven-decoration-store.lib.list-empty")}</div>
          </div>
        )}

        {!loading && this.hasMoreResults() && (
          <div style="text-align:center;padding:20px">
            <Button className={'Button Button--primary'} disabled={this.loading} loading={this.loading} onclick={() => this.loadMore()}>
              {app.translator.trans('ziven-decoration-store.lib.list-load-more')}
            </Button>
          </div>
        )}

        {loading && <div className="DecorationStore-loadMore">{loading}</div>}
      </div>
    );
  }

  loadMore() {
    this.loading = true;
    this.loadResults(this.purchaseHistoryList.length);
  }

  hasMoreResults() {
    return this.moreResults;
  }

  filterItem(e){
    $("#decorationStorePurchaseHistoryContainer").empty();
    this.purchaseHistoryList = [];
    this.loading = true;
    m.redraw();
    this.loadResults();
  }

  parseResults(results) {
    this.moreResults = !!results.payload.links && !!results.payload.links.next;
    [].push.apply(this.purchaseHistoryList, results);

    this.loading = false;
    m.redraw();
  }

  loadResults(offset = 0) {
    const filters = {
      item_type:this.filterItemType(),
      purchase_type:this.filterItemPurchaseType()
    };

    return app.store
      .find("decorationStorePurchaseHistory", {
        filter:filters,
        page: {
          offset,
        },
      })
      .catch(() => {})
      .then(this.parseResults.bind(this));
  }
}
